/**
 * Geometry constants + sub-brand list for the EKSELENS360 portfolio radar.
 */
export const RING_LEVELS = 4; // visual rings, mirrors the 4-level starter scale

export const SUB_BRANDS = [
  { code: "ITSM360", slug: "itsm360", service: "it-service-management-and-operational-excellence" },
  { code: "AI360", slug: "ai360", service: "ai-readiness-and-adoption" },
  { code: "DATA360", slug: "data360", service: "data-insight-and-performance" },
  { code: "PMO360", slug: "pmo360", service: "project-programme-and-pmo-improvement" },
  { code: "CHANGE360", slug: "change360", service: "business-change-and-adoption" },
  { code: "DIGITAL360", slug: "digital360", service: "digital-and-technology-transformation" },
  { code: "OPERATING360", slug: "operating360", service: "service-and-operating-model-transformation" },
  { code: "SUPPLIER360", slug: "supplier360", service: "supplier-and-technology-value-optimisation" },
  { code: "BENEFITS360", slug: "benefits360", service: "benefits-realisation-and-assurance" },
  { code: "GOVERN360", slug: "govern360", service: "governance-and-delivery-control" },
  { code: "CAPABILITY360", slug: "capability360", service: "capability-and-training-needs-analysis" },
  { code: "STAKEHOLDER360", slug: "stakeholder360", service: "stakeholder-engagement-and-communications" },
];

export const VB_W = 860; // viewBox width — extra horizontal room for side labels
export const VB_H = 760; // viewBox height
export const CENTER_X = VB_W / 2;
export const CENTER_Y = VB_H / 2;
export const RADIUS = 250;
export const LABEL_RADIUS = RADIUS + 56;
export const HOTSPOT_RADIUS = RADIUS + 26;

export const polar = (angleRad, dist) => ({
  x: CENTER_X + Math.cos(angleRad) * dist,
  y: CENTER_Y + Math.sin(angleRad) * dist,
});
